export const PROJECT_WHITEBOARD_CONFIG = {
    name            : 'Whiteboard',
    icon            : 'i5-whiteboard',
    image           : 'notes-docs',
    iconSvg         : 'isvg-whiteboard',
    url             : 'whiteboard',
    stringId        : 'whiteboard',
    description     : 'Create a new collaborative Whiteboard for visual brainstorming and planning.',
    menuName        : 'Whiteboard',
    inheritance     : false,
}
